import { setNumberLocale } from "~/utils/global.mjs";
import { tagOfCode } from "~/utils/locale";

// Keeps the amounts' format (utils/global.mjs, text2Price) in the dashboard's language, from the first page and at
// each change of language.
export default defineNuxtPlugin({
  name: "locale-format",
  // After the i18n module's plugin, which provides $i18n and the detected language.
  dependsOn: ["i18n:plugin"],
  setup(nuxtApp) {
    const apply = (code) => setNumberLocale(tagOfCode(code));
    apply(nuxtApp.$i18n?.locale?.value);
    nuxtApp.hook("i18n:localeSwitched", ({ newLocale }) => apply(newLocale));
  }
});
